import { render, staticRenderFns } from "./ForgottenPass.vue?vue&type=template&id=146beb16&"
import script from "./ForgottenPass.vue?vue&type=script&lang=js&"
export * from "./ForgottenPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports